"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stringEncodeAsBase16 = (input) => {
    let hex = '';
    for (let i = 0; i < input.length; i += 1) {
        const charCode = input.charCodeAt(i);
        const hexValue = charCode.toString(16);
        hex += hexValue.padStart(2, '0');
    }
    return hex;
};
exports.default = stringEncodeAsBase16;
